// AI Generated
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-filters-selector-item',
    templateUrl: './table-filters-selector-item.component.html',
    standalone: false,
})
export class TableFiltersSelectorItemComponent implements OnInit {
    @Input() item: any;
    @Input() filter: any;
    @Input() selected: boolean = false;
    @Input() template?: string | undefined;

    ngOnInit (): void {
        this.template = this.template || '';
    }
}
